export default __webpack_public_path__ + "img/edit-icon.151693cc.svg";